import { useTranslation } from 'react-i18next';
import { Flex } from '@mantine/core';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';

function AIModelExplore() {
  const { t } = useTranslation();
  return (
    <Flex direction="column" align="center" justify="center">
      <TextComponent variant="displayXLarge">{t('page.ai-explore.title')}</TextComponent>
      <TextComponent color="muted" variant="bodyMedium">
        {t('page.ai-explore.subtitle')}
      </TextComponent>
    </Flex>
  );
}

export default AIModelExplore;
